export default "__VITE_ASSET__P4hmyeJg__"